module.exports = __webpack_public_path__ + "img/istockphoto-1193290387-612x612.cab063c7.jpg";